import axios from '@/lib/axios';
import { PurchaseOrderContractTask, PurchaseOrderContractTaskDocument, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation, useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 0880. 発注案件契約タスクファイル一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:task_id/purchase_order_contract_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};

const purchaseOrderContractTaskDocuments = (props: Props): Promise<PurchaseOrderContractTaskDocument[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_documents`
  );
};

export const usePurchaseOrderContractTaskDocuments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderContractTaskDocuments(props),
  });
};

export const usePurchaseOrderContractTaskDocumentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'purchase_order_contract_tasks',
    props.task_id,
    'purchase_order_contract_task_documents',
  ];
};
